// src/features/knowledge-management/hooks/useKmQuery.js
import { useCallback, useEffect, useState } from 'react';

/**
 * Esegue fetcher() al mount / quando deps cambiano.
 * Restituisce { data, status, error, refetch }.
 * status: 'loading' | 'success' | 'error'
 */
export function useKmQuery(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);

  const run = useCallback(() => {
    let cancelled = false;
    setStatus((prev) => (prev === 'success' ? 'success' : 'loading')); // mantiene dati precedenti su refresh (§9.3)
    fetcher()
      .then((result) => {
        if (cancelled) return;
        setData(result);
        setStatus('success');
        setError(null);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setStatus('error');
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => run(), [run]);

  return { data, status, error, refetch: run };
}
